import { render, staticRenderFns } from "./toolbar-markets.vue?vue&type=template&id=6480e710"
import script from "./toolbar-markets.vue?vue&type=script&lang=js"
export * from "./toolbar-markets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports